import { useEffect, useState } from 'react';
import api from './api';
import { useGlobalContext } from '../store/GlobalContext';

type Person = { id?: number; uid?: string; isAdmin?: boolean; roles?: string | string[] };
export function isAppAdmin(user: Person | null | undefined): boolean {
  const roles = Array.isArray(user?.roles) ? user?.roles : (user?.roles || '').split(',');
  return !!user?.isAdmin || (roles || []).includes('admin');
}
export function canManageEstate(estate: { executor?: Person[] } | null | undefined, user: Person | null | undefined): boolean {
  return isAppAdmin(user) || !!(user && estate?.executor?.some(member => (user.uid && member.uid === user.uid) || (user.id && member.id === user.id)));
}
export function useCanManageEstate(): boolean {
  const { auth, selectedEstate } = useGlobalContext();
  const [canManage, setCanManage] = useState(false);
  useEffect(() => {
    let alive = true;
    setCanManage(false);
    if (isAppAdmin(auth.user)) { setCanManage(true); return; }
    if (!selectedEstate?.uuid) return;
    api.get(`/estates/${selectedEstate.uuid}`).then(({ data }) => {
      if (alive) setCanManage(canManageEstate(data, auth.user));
    }).catch(() => { if (alive) setCanManage(false); });
    return () => { alive = false; };
  }, [auth.user, selectedEstate?.uuid]);
  return canManage;
}
